var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdema(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 81,
    viewBox: "0 0 75 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0229 36.8236C34.9534 53.4894 24.3829 56.454 24.3829 68.041C24.3829 75.1933 30.389 80.997 37.5008 80.997C44.6126 80.997 50.6147 75.1893 50.6147 68.041C50.6147 56.454 40.0442 53.4894 37.9747 36.8236C37.9099 36.3255 37.0877 36.3255 37.0229 36.8236V36.8236ZM12.727 0.373613C10.6574 17.0394 0.0869141 19.9999 0.0869141 31.591C0.0869141 38.7393 6.08901 44.547 13.2008 44.547C20.3126 44.547 26.3147 38.7393 26.3147 31.591C26.3147 20.004 15.7442 17.0394 13.6747 0.373613C13.6139 -0.124538 12.7877 -0.124538 12.727 0.373613V0.373613ZM61.327 0.373613C59.2574 17.0394 48.6869 20.004 48.6869 31.591C48.6869 38.7393 54.689 44.547 61.8008 44.547C68.9126 44.547 74.9147 38.7393 74.9147 31.591C74.9147 20.004 64.3442 17.0394 62.2747 0.373613C62.2099 -0.124538 61.3877 -0.124538 61.327 0.373613V0.373613Z",
    fill: "#F8F8F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdema);
export default __webpack_public_path__ + "static/media/edema.b38f01f8c33f7767278d15c1d27eab14.svg";
export { ForwardRef as ReactComponent };